import React, { useState } from 'react';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import BobModal from '../../../components/BobModal';

import * as LookupActions from '../../../actions/lookupActions';

import * as classes from './AddNewEntityModal.module.css';

const ValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required()
});

const CreateSensorTypeModal = ({
    createSensorType,
    fetchSensorTypes,
    setCreateSensorTypeModalOpen,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            name: ''
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            setIsLoading(true);

            const body = { name: values.name };

            try {
                await createSensorType(body);
                await fetchSensorTypes();
                setIsLoading(false);
                setCreateSensorTypeModalOpen(false);
            } catch (error) {
                setIsLoading(false);
            }
        }
    });

    return (
        <BobModal
            title={'New Sensor Type'}
            hidebuttons={true}
            headerOverride={classes.ModalHeaderOverride}
            bodyOverride={classes.ModalBodyOverride}
            isRemoveFooter={true}
            onClose={() => setCreateSensorTypeModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <FormControl className={classes.Row}>
                    <TextField
                        className={classes.Input}
                        id="name"
                        name="name"
                        type="text"
                        value={formik.values.name}
                        label={<span>Sensor Type Name<span className={classes.required}> *</span></span>}
                        placeholder="Enter"
                        size="small"
                        onChange={formik.handleChange}
                        InputProps={{
                            onBlur: formik.handleBlur
                        }}
                        variant="outlined"
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                        error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                        helperText={Boolean(formik.touched.name) && formik.errors.name}
                    />
                </FormControl>
                <div className={classes.ButtonContainer}>
                    <BobCancelButton
                        className={classes.CancelButton}
                        disabled={isLoading}
                        onClick={() => setCreateSensorTypeModalOpen(false)}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        onClick={formik.handleSubmit}
                        label={'Create'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapDispatchToProps = {
    ...LookupActions
};

export default connect(null, mapDispatchToProps)(CreateSensorTypeModal);
